import React, { memo } from 'react';

const SummaryTileComponent = ({ label, value, description }) => (
  <div className="callout w100p">
    <h5 className="text-uppercase text-muted font-size-12 mt0">{label}</h5>
    <h3 className="mt0 text-bold text-primary">{value}</h3>
    <h6 className="mb0 text-muted">{description}</h6>
  </div>
);

export const SummaryTile = memo(SummaryTileComponent);
